import { of } from 'rxjs'
import { catchError, map, pluck } from 'rxjs/operators'
import { defineComponent } from 'vue'
import * as _ from 'lodash'

import { TrackingRoutes } from '@skinsoft/const'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'
import { CreateContainerForm } from './create-container-form'

export const CreateContainerModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sCreateContainerForm: CreateContainerForm,
    },
    template: require('./create-container-modal.html'),
    data() {
        return {
            mounted: false,
            // $containerDataStore is a Vue.prototype global installed by ContainerDataStore, not per-instance state
        }
    },
    methods: {
        open() {
            (this.$refs.modal as any).show()
        },
        onHide() {
            this.mounted = false
        },
        onShow() {
            this.mounted = true
        },
        onSubmit(values) {
            const newContainer = {}
            _.set(newContainer, `containerItemSchema.name.translatedString.${this.getAppLocale()}`, values.name)
            _.set(newContainer, 'containerItemSchema.openContainer', true)
            _.set(newContainer, 'identificationItemSchema.identifiers[0].identifier', values.identifier)
            if(values.itemType) {
                _.set(newContainer, 'descriptionItemSchema.itemType', [values.itemType])
            }
            _.set(newContainer, 'locationItemSchema.realTimeLocation.realTimeLocation', values.location?.id)
            const createContainer$ = (this as any).$containerDataStore
                .create({}, newContainer)
                .pipe(
                    pluck('id'),
                    map(id => {
                        return {
                            success: true,
                            data: id,
                        }
                    }),
                    catchError(error => {
                        const alertPayload = {
                            message: '',
                            variant: "danger"
                        };

                        let submitErrors:any = {}

                        if(error.status) {
                            switch(error.status) {
                                case 409:
                                    alertPayload.message = this.$t('container.alerts.errors.identificationNumberAlreadyAttributed') as string
                                    submitErrors.identifier = this.$t('container.validationErrors.identificationNumberAlreadyAttributed') as string
                                    break
                            }
                        }

                        this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                        return of({
                            success: false,
                            data: submitErrors,
                        })
                    }),
                )

                return new Promise((resolve, reject) => { // returning promise: see onSubmit specs final form
                    createContainer$.subscribe((res) => {
                        if(res.success) {
                            this.$router.push({
                                name: TrackingRoutes.CONTAINER,
                                params: { id: res.data as string },
                            })
                            // @ts-ignore
                            resolve()
                        } else {
                            resolve(res.data)
                        }
                    })
                })
        },
    },
})
